import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Menu,
  MenuItem,
  Grid,
  Card,
  Dialog,
  DialogContent,
  CardContent,
  Modal,
  Rating,
} from "@mui/material";
import axiosInstance from "./axios";
import IconButton from "@mui/material/IconButton";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import nexticon from "../images/nexticon.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";
import TwitterIcon from "@mui/icons-material/Twitter";
import grouplogo from "../images/Grouplogo.png";
import TIKTOK from "../images/TIKTOK.png";
import StarIcon from "@mui/icons-material/Star";
import google from "../images/google.png";
import PhoneIcon from "@mui/icons-material/Phone";
import menustar from "../images/menustar.png";
import CloseIcon from "@mui/icons-material/Close";
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { styled } from "@mui/system";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // MUI tick icon
import imageoffer from "../images/imageoffer.png";
import { t } from "i18next";
import { useTheme } from "@mui/material/styles";

const PriceButton = styled(Button)({
  background: "linear-gradient(to right, #7928CA, #FF0080)",
  color: "white",
  borderRadius: "20px",
  padding: "3px 12px",
  fontWeight: "bold",
  textTransform: "none",
  letterSpacing: "0.9px",
});

const Specials = () => {
  const [loading, setLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [getBusinessData, setGetBusinessData] = useState({});
  const [businessId, setBusinessId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [Followusopen, setFollowusOpen] = useState(false);
  const [placeId, setPlaceId] = useState("");
  const [specialModal, setSpecialModal] = useState(false);
  const [selectedSpecial, setSelectedSpecial] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [codeCopied, setCodeCopied] = useState(false);
  const { code } = useParams();
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const muiTheme = useTheme();
  const themeColors = muiTheme.palette.pointGenie;
  const palette = {
    bg: themeColors.bg,
    card: themeColors.card,
    surfaceMuted: themeColors.surfaceMuted,
    border: themeColors.border,
    textPrimary: themeColors.text,
    textSecondary: themeColors.text2,
    textMuted: themeColors.textMuted,
    accent: themeColors.accent,
    accentBlue: themeColors.accentBlue,
    accentBlueBg: themeColors.accentBlueBg,
    success: themeColors.success,
    onAccent: themeColors.onAccent,
    overlayButton:
      muiTheme.palette.mode === "dark"
        ? "rgba(15,23,42,0.88)"
        : "rgba(255,255,255,0.92)",
    overlayButtonHover:
      muiTheme.palette.mode === "dark"
        ? "rgba(30,41,59,0.96)"
        : "#FFFFFF",
    shimmer:
      muiTheme.palette.mode === "dark"
        ? "linear-gradient(90deg, #111827 25%, #1E293B 50%, #111827 75%)"
        : "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    shadow:
      muiTheme.palette.mode === "dark"
        ? "0 14px 34px rgba(0,0,0,0.34)"
        : "0 12px 26px rgba(17, 17, 17, 0.08)",
  };

  useEffect(() => {
    const fetchBusinessData = async () => {
      setLoading(true);
      setIsPageLoading(true);
      try {
        const response = await axiosInstance.post(
          "payments.php?method=fetch_business",
          { plate_code: code }
        );
        if (
          response.data?.status === "success" &&
          response.data?.place_details
        ) {
          setGetBusinessData(response.data.place_details);
        } else {
          console.error("Invalid API response structure:");
        }

        const fetchedPlaceId = response.data?.place_details?.place_id;
        if (fetchedPlaceId) {
          setPlaceId(fetchedPlaceId);
        }

        const business = response?.data?.id;
        if (business) {
          setBusinessId(business);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
        setIsPageLoading(false);
      }
    };
    fetchBusinessData();
  }, [code]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSocialClick = (platform) => {
    let shareUrl = "";

    switch (platform) {
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "instagram":
        shareUrl = `https://www.instagram.com/`; // Instagram doesn't allow direct text sharing
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      case "telegram":
        shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
          currentUrl
        )}`;
        break;
      default:
        break;
    }

    // Open the URL in a new tab
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }

    handleClosesocialmedia(); // Close the dropdown after clicking
  };

  const handleClosesocialmedia = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    // setOpen(false);
    // setSelectedItem(null);
    setAnchorEl(null);
  };

  const handleCopy = (text) => {
    if (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setOpenSnackbar(true);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  const handleCodeCopy = (code) => {
    if (code) {
      navigator.clipboard
        .writeText(code)
        .then(() => {
          setCodeCopied(true);
        })
        .catch((err) => {
          console.log("Failed to copy text:", err);
        });
    }
  };

  // Function to toggle modal
  const handleFollowusOpen = () => setFollowusOpen(true);
  const handleFollowusClose = () => setFollowusOpen(false);

  const handleOpenSpecials = (coupon) => {
    setSelectedSpecial(coupon);
    setSpecialModal(true);
  };
  const handleCloseSpecials = () => {
    setSpecialModal(false);
    setSelectedSpecial(null);
  };

  const handleGoogleProviderClick = async () => {
    const fallbackUrl = getBusinessData?.provider?.google?.proivder_link;
    const url = fallbackUrl;
    if (!url) return; // Do nothing if no valid URL
    window.open(url, "_blank");
    try {
      await axiosInstance.post("payments.php?method=provider_clicks", {
        business_id: businessId,
        provider: "google",
      });
    } catch (error) {
      console.error("providerclicking failed", error);
    }
  };

  const handleProviderClick = async (item) => {
    if (item.provider.toLowerCase() === "whatsapp") {
      const whatsappUrl = `https://wa.me/${item.providerUrl.replace(
        /\D/g,
        ""
      )}`;
      window.open(whatsappUrl, "_blank");
    } else {
      window.open(
        item.providerUrl.startsWith("http")
          ? item.providerUrl
          : `https://${item.providerUrl}`,
        "_blank"
      );
    }
    try {
      await axiosInstance.post("payments.php?method=provider_clicks", {
        business_id: businessId,
        provider: item.provider,
      });
    } catch (error) {
      console.error("providerclicking failed", error);
    }
  };

  const formatReviewCount = (count) => {
    if (!count && count !== 0) return "";
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1).replace(/\.0$/, "")}k`;
    }
    return count;
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: palette.bg, color: palette.textPrimary }}>
      {isPageLoading ? (
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: palette.bg,
            padding: "20px",
          }}
        >
          <Box sx={{ display: "flex ", justifyContent: "space-between" }}>
            <Typography
              sx={{
                width: "28px",
                height: "28px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "25px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>
            <Box display={"flex"} alignItems={"center"} gap={"3px"}>
              <Typography
                sx={{
                  width: "28px",
                  height: "28px",
                  background: palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.8s infinite",
                  borderRadius: "25px",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "-200% 0" },
                    "100%": { backgroundPosition: "200% 0" },
                  },
                }}
              ></Typography>
              <Typography
                sx={{
                  width: "40px",
                  height: "20px",
                  background: palette.shimmer,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 1.8s infinite",
                  borderRadius: "6px",
                  "@keyframes shimmer": {
                    "0%": { backgroundPosition: "-200% 0" },
                    "100%": { backgroundPosition: "200% 0" },
                  },
                }}
              ></Typography>
            </Box>
          </Box>
          <Box
            sx={{
              border: `2px solid ${palette.border}`,
              borderRadius: "8px",
              p: "10px",
              mt: "10px",
            }}
          >
            <Typography
              sx={{
                width: "160px",
                height: "18px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>

            <Typography
              sx={{
                width: "150px",
                height: "20px",
                mt: "10px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>

            <Typography
              sx={{
                width: "150px",
                height: "20px",
                mt: "10px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "6px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            ></Typography>
          </Box>
          {/* Shimmer Text */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "85%",
                height: "160px",
                mt: "50px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "14px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            />
            <Box
              sx={{
                width: "85%",
                height: "160px",
                mt: "20px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "14px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            />
            <Box
              sx={{
                width: "85%",
                height: "160px",
                mt: "20px",
                background: palette.shimmer,
                backgroundSize: "200% 100%",
                animation: "shimmer 1.8s infinite",
                borderRadius: "14px",
                "@keyframes shimmer": {
                  "0%": { backgroundPosition: "-200% 0" },
                  "100%": { backgroundPosition: "200% 0" },
                },
              }}
            />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: palette.bg,
            borderRadius: "0px 0px 28px 28px",
            pb: "20px",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Box
              sx={{ width: "100%", height: "45px", position: "relative" }}
            ></Box>
            <Box sx={{ position: "absolute", top: "15px", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: "18px",
                  width: "100%",
                }}
              >
                <IconButton
                  onClick={() => navigate(`/place/${code}`)}
                  sx={{
                    backgroundColor: palette.overlayButton,
                    color: palette.textPrimary,
                    borderRadius: "50%",
                    width: "25px",
                    height: "25px",
                    boxShadow: palette.shadow,
                    "&:hover": {
                      backgroundColor: palette.overlayButtonHover,
                    },
                  }}
                >
                  <ArrowBackIosIcon sx={{ color: palette.textPrimary, fontSize: 20 }} />
                </IconButton>
                <Box>
                  <Box display={"flex"} gap={0.5} alignItems={"center"}>
                    <Box
                      component="img"
                      src={nexticon}
                      width={"32px"}
                      height={"32px"}
                      //   onClick={handleClick}
                      sx={{ cursor: "pointer" }}
                    />
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: "500",
                        letterSpacing: "0px",
                        lineHeight: "14px",
                        color: `${palette.textPrimary} !important`,
                      }}
                      onClick={handleClick}
                    >
                      {t("Share")}
                    </Typography>
                    {/* Dropdown Menu */}
                    {/* <ClickAwayListener onClickAway={handleClose}> */}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      PaperProps={{
                        sx: {
                          mt: 1,
                          borderRadius: "8px",
                          backgroundColor: palette.card,
                          color: palette.textPrimary,
                          border: `1px solid ${palette.border}`,
                          boxShadow: palette.shadow,
                          width: "200px",
                          p: "5px",
                        },
                      }}
                    >
                      {/* WhatsApp */}
                      <MenuItem
                        onClick={() => handleSocialClick("whatsapp")}
                        sx={{ gap: 1 }}
                      >
                        <WhatsAppIcon sx={{ color: "#25D366" }} />
                        <Typography>WhatsApp</Typography>
                      </MenuItem>

                      {/* Instagram */}
                      <MenuItem
                        onClick={() => handleSocialClick("instagram")}
                        sx={{ gap: 1 }}
                      >
                        <InstagramIcon sx={{ color: "#E4405F" }} />
                        <Typography>Instagram</Typography>
                      </MenuItem>

                      {/* {facebook} */}

                      <MenuItem
                        onClick={() => handleSocialClick("facebook")}
                        sx={{ gap: 1 }}
                      >
                        <FacebookIcon sx={{ color: "#E4405F" }} />
                        <Typography>Facebook</Typography>
                      </MenuItem>

                      {/* Twitter */}
                      <MenuItem
                        onClick={() => handleSocialClick("twitter")}
                        sx={{ gap: 1 }}
                      >
                        <TwitterIcon sx={{ color: "#1DA1F2" }} />
                        <Typography>Twitter</Typography>
                      </MenuItem>

                      {/* Telegram */}
                      <MenuItem
                        onClick={() => handleSocialClick("telegram")}
                        sx={{ gap: 1 }}
                      >
                        <TelegramIcon sx={{ color: "#0088CC" }} />
                        <Typography>Telegram</Typography>
                      </MenuItem>
                    </Menu>
                    {/* </ClickAwayListener> */}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ paddingRight: "0px", paddingTop: "12px" }}></Box>
          <Card
            sx={{
              gap: "4px",
              display: "flex",
              alignItems: "start",
              mx: "18px",
              py: "14px",
              border: `1px solid ${palette.border}`,
              borderRadius: "20px",
              boxShadow: palette.shadow,
              backgroundColor: palette.card,
              //   mb:"10px"
            }}
          >
            <Box sx={{ px: "15px", width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                {loading ? (
                  <Box
                    sx={{
                      width: "180px",
                      height: "18px",
                      background: palette.shimmer,
                      backgroundSize: "200% 100%",
                      animation: "shimmer 1.5s infinite",
                      borderRadius: "4px",
                      "@keyframes shimmer": {
                        "0%": { backgroundPosition: "-200% 0" },
                        "100%": { backgroundPosition: "200% 0" },
                      },
                    }}
                  />
                ) : (
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "20px",
                      fontWeight: "800",
                      letterSpacing: "0px",
                      lineHeight: "24px",
                      color: palette.textPrimary,
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {getBusinessData?.name}
                  </Typography>
                )}
              </Box>
              <Grid container gap={"5px"} justifyContent={"space-between"}>
                <Grid xs={12}>
                  <Box display={"flex"} gap={0.8} pt={"10px"}>
                    {loading ? (
                      <Box
                        sx={{
                          width: "160px",
                          height: "16px",
                          background:
                            palette.shimmer,
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                          borderRadius: "4px",
                          "@keyframes shimmer": {
                            "0%": { backgroundPosition: "-200% 0" },
                            "100%": { backgroundPosition: "200% 0" },
                          },
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "50%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                              gap: "2px",
                            }}
                          >
                            {/* <Box component="img" src={menustar} pt={"2px"} /> */}
                            <Typography
                              sx={{
                                fontSize: "14px",
                                fontWeight: "400",
                                fontFamily: "Roboto",
                                // lineHeight: "25.88px",
                                letterSpacing: "-0.65px",
                                color: "#F97731",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              {getBusinessData?.rating &&
                                (parseFloat(getBusinessData.rating) % 1 === 0
                                  ? `${parseFloat(
                                      getBusinessData.rating
                                    ).toFixed(1)}`
                                  : getBusinessData.rating)}

                              <Rating
                                value={parseFloat(getBusinessData.rating)}
                                readOnly
                                precision={0.1}
                                sx={{ fontSize: "12px" }}
                              />
                            </Typography>
                            <Box
                              component="span"
                              sx={{
                                fontSize: "14px",
                                fontWeight: "500",
                                fontFamily: "Roboto",
                                // lineHeight: "25.88px",
                                letterSpacing: "-0.3px",
                                color: palette.textMuted,
                                paddingLeft: "1px",
                              }}
                            >
                              (
                              {formatReviewCount(getBusinessData?.review_count)}{" "}
                              reviews)
                            </Box>
                          </Box>
                          {loading ? (
                            <Box
                              sx={{
                                width: "160px",
                                height: "16px",
                                background:
                                  palette.shimmer,
                                backgroundSize: "200% 100%",
                                animation: "shimmer 1.5s infinite",
                                borderRadius: "4px",
                                mt: "4px",
                                "@keyframes shimmer": {
                                  "0%": { backgroundPosition: "-200% 0" },
                                  "100%": { backgroundPosition: "200% 0" },
                                },
                              }}
                            />
                          ) : (
                            <>
                              {getBusinessData?.website && (
                                <Box>
                                  <Typography
                                    sx={{
                                      fontFamily: "Roboto",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      letterSpacing: "0px",
                                      lineHeight: "14px",
                                      color: palette.accent,
                                      wordBreak: "break-word",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    <a
                                      href={getBusinessData?.website}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      <LanguageIcon
                                        sx={{
                                          color: palette.accent,
                                          fontSize: "18px",
                                          mr: "4px",
                                        }}
                                      />
                                      {t("Website")}
                                    </a>
                                  </Typography>
                                </Box>
                              )}

                              <Box
                                display={"flex"}
                                gap={0.8}
                                pt={"4px"}
                                pb={"8px"}
                              >
                                {/* <Box component="img" src={call} width={"14px"} height={"14px"} /> */}
                                <PhoneIcon
                                  fontSize="14px"
                                  sx={{ color: palette.accent }}
                                />
                                <Typography
                                  sx={{
                                    fontFamily: "Roboto",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    letterSpacing: "0px",
                                    lineHeight: "14px",
                                    color: palette.accent,
                                    cursor: "pointer",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                  }}
                                  onClick={() =>
                                    window.open(
                                      `tel:${getBusinessData.telephone}`
                                    )
                                  }
                                >
                                  {getBusinessData?.telephone ||
                                    "No phone number available"}
                                </Typography>
                              </Box>
                            </>
                          )}
                        </Box>
                        <Box sx={{ width: "50%" }}>
                          <Box sx={{ textAlign: "center" }}>
                            { getBusinessData?.provider?.google && (
                                <Button
                                  sx={{
                                    color: "white",
                                    width: "100%",
                                    fontSize: "9px",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    backgroundColor: palette.accent,
                                    textTransform: "capitalize",
                                    borderRadius: "8px",
                                    py: "6px",
                                    "@media (max-width:367px)": {
                                      width: "100%",
                                      px: "0px",
                                    },
                                  }}
                                  onClick={() => handleGoogleProviderClick()}
                                >
                                  <img
                                    src={google}
                                    alt="Google"
                                    style={{
                                      width: "12px",
                                      height: "auto",
                                      marginRight: "6px",
                                    }}
                                  />
                                  {t("Leave us a Google Review")}
                                </Button>
                              )}
                            {getBusinessData?.provider &&
                              Object.keys(getBusinessData.provider).length >
                                0 && (
                                <Button
                                  sx={{
                                    color: "white",
                                    width: "100%",
                                    fontSize: "10px",
                                    fontFamily: "Roboto",
                                    fontWeight: "500",
                                    backgroundColor: palette.accent,
                                    textTransform: "capitalize",
                                    borderRadius: "8px",
                                    py: "6px",
                                    mt: "4px",
                                    "@media (max-width:367px)": {
                                      width: "100%",
                                      px: "0px",
                                    },
                                    "& > svg": {
                                      mr: "1px", // Adds space between text and first icon
                                    },
                                  }}
                                  onClick={handleFollowusOpen}
                                >
                                  <KeyboardDoubleArrowRightIcon
                                    sx={{ fontSize: "18px", ml: "0px" }}
                                  />
                                  {t("Connect With Us")}
                                </Button>
                              )}
                          </Box>
                          <Dialog
                            open={Followusopen}
                            onClose={handleFollowusClose}
                            fullWidth
                            maxWidth="sm"
                          >
                            <DialogContent
                              sx={{ p: "20px", position: "relative" }}
                            >
                              {/* Close Icon at Top Right Corner */}
                              <IconButton
                                onClick={handleFollowusClose}
                                sx={{
                                  position: "absolute",
                                  top: 1,
                                  right: 1,
                                  color: palette.textPrimary,
                                }}
                              >
                                <CloseIcon sx={{ fontSize: "18px" }} />
                              </IconButton>

                              {/* Heading Text */}
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontFamily: "Roboto",
                                  color: palette.textMuted,
                                  mb: 2,
                                  mt: 1,
                                }}
                              >
                                {t(
                                  "Connect With Us Share Your Feedback. Your Opinion Matters to Us!"
                                )}
                              </Typography>

                              {/* Social Media Links */}
                              {getBusinessData?.provider &&
                                (() => {
                                  const validProviders = Object.entries(
                                    getBusinessData.provider
                                  )
                                    .filter(
                                      ([provider, data]) =>
                                        data.proivder_link &&
                                        provider.toLowerCase() !== "google"
                                    )
                                    .map(([provider, data]) => {
                                      let providerIcon;
                                      let providerName = data.proivder_label; // Use the label from data
                                      let providerUrl = data.proivder_link; // Use the link from data
                                      if (provider.toLowerCase() === "yelp") {
                                        providerIcon = (
                                          <StarIcon
                                            sx={{
                                              color: "#D32323",
                                              fontSize: 30,
                                            }}
                                          />
                                        );
                                      } else if (
                                        provider.startsWith("customprovider_")
                                      ) {
                                        providerIcon = (
                                          <InsertLinkIcon
                                            sx={{
                                              color: palette.accent,
                                              fontSize: 30,
                                            }}
                                          />
                                        );
                                      } else {
                                        switch (provider.toLowerCase()) {
                                          case "facebook":
                                            providerIcon = (
                                              <FacebookIcon
                                                sx={{
                                                  color: "#1877F2",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Facebook";
                                            break;
                                          case "instagram":
                                            providerIcon = (
                                              <InstagramIcon
                                                sx={{
                                                  color: "#E4405F",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Instagram";
                                            break;
                                          case "tiktok":
                                            providerIcon = (
                                              <Box
                                                component="img"
                                                src={TIKTOK}
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            );
                                            providerName = "TikTok";
                                            break;
                                          case "whatsapp":
                                            providerIcon = (
                                              <WhatsAppIcon
                                                sx={{
                                                  color: "#25D366",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "WhatsApp";
                                            break;
                                          case "yelp":
                                            providerIcon = (
                                              <StarIcon
                                                sx={{
                                                  color: "#D32323",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "Yelp";
                                            break;
                                          case "tripadvisor":
                                            providerIcon = (
                                              <StarIcon
                                                sx={{
                                                  color: "#00AF87",
                                                  fontSize: 30,
                                                }}
                                              />
                                            );
                                            providerName = "TripAdvisor";
                                            break;
                                          case "pointgenie":
                                            providerIcon = (
                                              <Box
                                                component="img"
                                                src={grouplogo}
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            );
                                            providerName = "PointGenie";
                                            break;
                                          default:
                                            return null;
                                        }
                                      }
                                      return {
                                        provider,
                                        providerUrl,
                                        providerIcon,
                                        providerName,
                                      };
                                    })
                                    .filter(Boolean); // Remove nulls

                                  const pairs = [];
                                  for (
                                    let i = 0;
                                    i < validProviders.length;
                                    i += 2
                                  ) {
                                    pairs.push(validProviders.slice(i, i + 2));
                                  }

                                  return pairs.map((pair, index) => (
                                    <Grid
                                      container
                                      key={index}
                                      sx={{
                                        px: { xs: "", sm: "20px" },
                                        mb: "5px",
                                        gap: "4px",
                                      }}
                                    >
                                      {pair.map((item) => (
                                        <Grid
                                          item
                                          xs={
                                            pair.length === 1 &&
                                            (validProviders.length === 1 ||
                                              validProviders.length % 2 !== 0)
                                              ? 12
                                              : 5.8
                                          }
                                          key={item.provider}
                                          sx={{
                                            border: `1px solid ${palette.accent}`,
                                            borderRadius: "8px",
                                            py: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            gap: "6px",
                                          }}
                                          onClick={() =>
                                            handleProviderClick(item)
                                          }
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {item.providerIcon}
                                          </Box>
                                          <Typography
                                            sx={{
                                              fontSize: {
                                                xs: "13px",
                                                sm: "14px",
                                              },
                                              fontWeight: "700",
                                              fontFamily: "Roboto",
                                              lineHeight: "14px",
                                              color: palette.accent,
                                            }}
                                          >
                                            {item.providerName}
                                          </Typography>
                                        </Grid>
                                      ))}
                                    </Grid>
                                  ));
                                })()}
                            </DialogContent>
                          </Dialog>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Box>
      )}

      <Box>
        <Typography
          sx={{
            fontFamily: "Roboto",
            fontSize: "19px",
            fontWeight: "800",
            letterSpacing: "0px",
            lineHeight: "22px",
            color: palette.textPrimary,
            pl: "24px",
            mt: 2,
          }}
        >
          {t("Offers")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pt: "20px",
            flexDirection: "column",
          }}
        >
          {getBusinessData?.specials?.length > 0 ? (
            getBusinessData.specials.map((coupon, index) => (
              <Card
                key={coupon.id}
                sx={{
                  maxWidth: 320,
                  borderRadius: "16px",
                  border: `2px dashed ${palette.border}`,
                  boxShadow: palette.shadow,
                  background: palette.card,
                  color: palette.textPrimary,
                  width: "80%",
                  marginBottom: "12px",
                }}
              >
                <CardContent
                  sx={{
                    padding: "15px 15px 0px 15px",
                    "&:last-child": { paddingBottom: "15px" },
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Box
                      component="img"
                      src={coupon?.image || imageoffer}
                      sx={{
                        borderRadius: "25px",
                        objectFit: "cover",
                        width: "50px",
                        height: "50px",
                      }}
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: "Roboto",
                        fontSize: "16px",
                        fontWeight: "600",
                        lineHeight: "18px",
                        color: palette.textPrimary,
                      }}
                    >
                      {coupon?.menu_name}
                    </Typography>
                  </Box>

                  <Typography
                    variant="caption"
                    color="textSecondary"
                    sx={{
                      mt: 2,
                      mb: "1px",
                      display: "block",
                      fontFamily: "Roboto",
                      fontSize: "13px",
                      fontWeight: "500",
                      lineHeight: "18px",
                      color: palette.textMuted,
                    }}
                  >
                    Expires
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: palette.textPrimary,
                    }}
                  >
                    {coupon?.expiration_date}
                  </Typography>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography
                      variant="caption"
                      color="primary"
                      sx={{
                        cursor: "pointer",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: palette.accent,
                      }}
                      onClick={() => handleOpenSpecials(coupon)}
                    >
                      More details..
                    </Typography>
                    <Box>
                      <PriceButton>
                        {coupon?.coupon_code?.replace(/"/g, "")}
                      </PriceButton>
                      <ContentCopyIcon
                        sx={{ fontSize: "18px", ml: "8px", cursor: "pointer" }}
                        onClick={() => handleCopy(coupon?.coupon_code)}
                      />
                      <Snackbar
                        open={openSnackbar}
                        autoHideDuration={2000}
                        onClose={() => setOpenSnackbar(false)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                      >
                        <SnackbarContent
                          message={
                            <Box display="flex" alignItems="center" gap={1}>
                              <CheckCircleIcon
                                sx={{
                                  fontSize: 20,
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              />
                              <span>Coupon code copied</span>
                            </Box>
                          }
                          sx={{
                            backgroundColor: "green",
                            color: "#fff",
                            borderRadius: "8px",
                            fontWeight: 500,
                            fontFamily: "Roboto",
                            py: "0px",
                          }}
                        />
                      </Snackbar>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography variant="body1">{t("No Offers Available")}</Typography>
          )}
        </Box>
      </Box>

      <Modal open={specialModal} onClose={handleCloseSpecials}>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            bgcolor: palette.card,
            color: palette.textPrimary,
            boxShadow: palette.shadow,
            pb: "35px",
            borderTopLeftRadius: "35px",
            borderTopRightRadius: "35px",
            maxHeight: "100vh",
            overflowY: "auto",
          }}
        >
          <IconButton
            onClick={handleCloseSpecials}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: palette.textPrimary,
              backgroundColor: palette.overlayButton,
              width: "28px",
              height: "28px",
            }}
          >
            <CloseIcon sx={{ fontSize: "18px" }} />
          </IconButton>

          <>
            <Box
              component="img"
              src={selectedSpecial?.image || imageoffer}
              width={"100%"}
              height={"100%"}
              sx={{}}
            />
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontSize: "18px",
                fontWeight: "700",
                lineHeight: "16px",
                color: palette.textPrimary,
                px: "16px",
                pt: "16px",
              }}
            >
              {selectedSpecial?.menu_name || " name not available"}
            </Typography>
            <Typography
              sx={{
                pt: "8px",
                px: "18px",
                fontFamily: "Roboto",
                fontSize: "15px",
                fontWeight: "600",
                color: palette.accent,
              }}
            >
              ${selectedSpecial?.price}
            </Typography>
            <Typography
              sx={{
                pt: "4px",
                px: "18px",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "500",
                color: palette.textSecondary,
              }}
            >
              Expires on {selectedSpecial?.expiration_date}
            </Typography>
            <Box
              sx={{
                px: "18px",
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "500",
                pt: "3px",
                color: palette.textSecondary,
              }}
            >
              Coupon code : {""}
              <Typography
                component={"span"}
                sx={{
                  background: "linear-gradient(to right, #7928CA, #FF0080)",
                  color: "white",
                  borderRadius: "20px",
                  padding: "3px 12px",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: "14px",
                  letterSpacing: "0.9px",
                  ml: "7px",
                }}
              >
                {selectedSpecial?.coupon_code?.replace(/"/g, "")}
              </Typography>
              <ContentCopyIcon
                sx={{ fontSize: "18px", ml: "6px", cursor: "pointer" }}
                onClick={() => handleCodeCopy(selectedSpecial?.coupon_code)}
              />
              <Snackbar
                open={codeCopied}
                autoHideDuration={2000}
                onClose={() => setCodeCopied(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <SnackbarContent
                  message={
                    <Box display="flex" alignItems="center" gap={1}>
                      <CheckCircleIcon sx={{ fontSize: 20, color: "white" }} />
                      <span>Coupon code copied</span>
                    </Box>
                  }
                  sx={{
                    backgroundColor: "green", // your green color
                    color: "#fff",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontFamily: "Roboto",
                    py: "0px",
                  }}
                />
              </Snackbar>
            </Box>

            <Typography
              sx={{
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "16px",
                color: palette.textMuted,
                px: "16px",
                pt: "3px",
                py: "10px",
              }}
            >
              {selectedSpecial?.menu_description}
            </Typography>
          </>
        </Box>
      </Modal>
    </Box>
  );
};

export default Specials;
